<!-- Trigger button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    @if (user) {
        <span
            class="flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold text-white"
            [ngClass]="getAvatarBgClass(user)"
        >
            {{ getInitials(user) }}
        </span>
    } @else {
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    }
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <!-- Identity header (not clickable) -->
    <button mat-menu-item disabled class="!opacity-100 !cursor-default">
        <span class="flex flex-col leading-none">
            <span class="text-xs text-secondary">Signed in as</span>
            <span class="mt-1 text-sm font-semibold">
                {{ user?.firstName }} {{ user?.lastName }}
            </span>
            <span class="mt-0.5 text-xs text-secondary">{{ user?.email }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <!-- Profile menu item hidden for MVP — self-service profile page is V2 scope.
         See docs/backlog/MODULE-2-V2-BACKLOG.md BL2-04. Code kept, not deleted.
    <button mat-menu-item (click)="navigateToProfile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    -->
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>
